import { Component, inject } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {filter, map, switchMap} from 'rxjs/operators';
import {ProjectReferenceService} from '../../services/project-reference.service';
import {propertyOrder} from '../../models/project-reference-detail.response';
import {referenceStatusTranslation} from '../../models/project-reference';
import {Mode} from '../../models/mode';
import {BehaviorSubject, combineLatest} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {NavigationService} from '../../services/navigation.service';
import {getRelevantProjectHandle} from '../../utils/project-name';

@Component({
    selector: 'app-project-reference-detail',
    templateUrl: './project-reference-detail.component.html',
    standalone: false
})
export class ProjectReferenceDetailComponent {
    private projectReferenceService = inject<ProjectReferenceService>('ProjectReferenceService' as any);
    private navigationService = inject(NavigationService);
    private route = inject(ActivatedRoute);
    private toastr = inject(ToastrService);

    refresh$ = new BehaviorSubject(null);
    getRelevantProjectHandle = getRelevantProjectHandle;

    projectReferenceId$ = this.route.paramMap.pipe(
        map(paramMap => {
            const value = paramMap.get('id');

            return value !== null ? +value : -1;
        }),
        filter(id => id > 0)
    );
    detail$ = combineLatest([
        this.refresh$,
        this.projectReferenceId$
    ]).pipe(
        map(([_, projectReferenceId]) => projectReferenceId),
        switchMap((id) => {
            return this.projectReferenceService.detail(id)
        }),
        map(it => {
            if (it.primaryPhoto === null && it.imageUrl !== null) {
                it.primaryPhoto = {
                    originalUrl: it.imageUrl,
                    focusX: 0,
                    focusY: 0,
                    srcset: {}
                };
            }
            return it;
        })
    );
    propertyOrder = propertyOrder;
    readonly statusTranslations = referenceStatusTranslation;

    modeSubject = new BehaviorSubject<Mode>(Mode.Read);
    mode$ = this.modeSubject.asObservable();

    tab = 'contract';
    id = this.route.snapshot.params.id;

    async saveText(text: string): Promise<void> {
        try {
            await this.projectReferenceService.updateReference(this.route.snapshot.params.id, text).toPromise();
        } catch (e) {
            this.toastr.error('Onverwachte error opgetreden.');
            console.error("Error while saving text", e);
        } finally {
            this.refresh$.next(null);
        }
    }

    async publishReference(): Promise<void> {
        try {
            await this.projectReferenceService.publishReference(this.route.snapshot.params.id).toPromise();
        } catch (e) {
            this.toastr.error('Publiceren mislukt')
        } finally {
            this.refresh$.next(null);
        }
    }

    async unpublishReference(): Promise<void> {
        try {
            await this.projectReferenceService.unpublishReference(this.route.snapshot.params.id).toPromise();
        } catch (e) {
            this.toastr.error('Terug brengen naar concept mislukt')
        } finally {
            this.refresh$.next(null);
        }
    }

    onModeChange(mode: Mode) {
        this.modeSubject.next(mode);

        if (mode === Mode.Read) {
            this.refresh$.next(null);
        }
    }

    onTabChange($event: string): void {
        this.tab = $event;
    }
}

